module.exports = __webpack_public_path__ + "variables.less";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=variables.less!./src/variables.less
// module id = 111
// module chunks = 0